module.exports = __webpack_public_path__ + "img/chinesecompany158.fa7b6e8e.png";